import React, { useRef, useState } from "react";
import FormikInput from "../../../../Components/Formik/FormikInput";
import { useFormikContext } from "formik";
import { COMPANY_DOMAIN } from "../../../../utilities/constants";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
import { useSession } from "../../../../authentications/SessionContext";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { checkApi } from "../../../../DataApi/onboarding/checkApi";

const VtexVerifyEmailStep = ({
  setIsVerified,
  themeOptions,
  isSecondaryContact,
  setIsSecondaryContact,
  handleCloseLoader,
}) => {
  const { setFieldValue, values, errors, touched, setFieldTouched } =
    useFormikContext();
  const { language, translations } = useLanguage();
  const { sessionInfo } = useSession();
  const t = translations[language];
  const domainRef = useRef(null);

  const onChange = () => {
    setIsVerified(false);
  };
  const toggleSwitch = () => {
    setIsSecondaryContact(!isSecondaryContact);
  };
  const onChangeBusinessName = (e) => {
    const { name, value } = e.target;
    // console.log("on change business name", name, value);
    setFieldValue(name, value);
    if (domainRef.current) {
      const domainValueFiltered = value
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase()
        .slice(0, 30);
      domainRef.current.value = domainValueFiltered;
      setFieldValue("domain_name", domainValueFiltered);
      setFieldValue("domain", `${domainValueFiltered}.${COMPANY_DOMAIN}`);
      if (sessionInfo.isVTEX === true) {
        setFieldValue("website_name", value);
        const defaultTheme =
          themeOptions.find(
            (theme) => theme.label === "Business" || theme.label === "Default"
          ) || themeOptions[0];
        // console.log("theme options", themeOptions, defaultTheme, value);
        if (defaultTheme) {
          setFieldValue("theme", defaultTheme.value);
        }
      }
    }
  };
  // console.log("company domain", COMPANY_DOMAIN, process.env);
  return (
    <>
      <div
        className="col-12 row me-0 pe-0"
        style={{
          border: "1px dashed rgb(203, 203, 203)",
          borderRadius: "15px",
        }}
      >
        <div className="col-12 mt-3">
          <h6 className="text-center text-secondary fw-bold">
            {t["Primary Contact Details"]}
          </h6>
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikInput
            name="first_name"
            placeholder={t["First Name"] + "*"}
            data-tooltip-id="fNameTooltip"
            data-tooltip-content={t["First Name"] + "*"}
          />
          <ReactTooltip id="fNameTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikInput
            name="last_name"
            placeholder={t["Last Name"] + "*"}
            data-tooltip-id="lNameTooltip"
            data-tooltip-content={t["Last Name"] + "*"}
          />
          <ReactTooltip id="lNameTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikInput
            onChange={onChange}
            handleOnBlur={async (e) => {
              const { value, name } = e.target;
              setFieldTouched(name, true);
              // console.log("first", value);
              // Call the API to check if the account number exists
              try {
                const response = await Promise.all([
                  checkApi({
                    params: { user: value },
                    endpoint: "/onboarding/user_check",
                  }),
                ]);

                const [userCheckResponse = {}] = response;

                if (userCheckResponse?.result?.result?.exists === true) {
                  // console.log(
                  //   "check account number response if exists",
                  //   accountCheckResponse?.result?.result?.exists
                  // );

                  setFieldValue("email_exists", true);
                } else {
                  setFieldValue("email_exists", false);
                }
              } catch (error) {
                console.error("Error checking account number:", error);
              } finally {
                handleCloseLoader();
              }
            }}
            name="email"
            placeholder={t["Email Address"] + "*"}
            data-tooltip-id="emailTooltip"
            data-tooltip-content={t["Email Address"] + "*"}
          />
          <ReactTooltip id="emailTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-6 col-12 d-flex">
          <FormikInput name="phone_prefix" readOnly />
          <div className="d-flex flex-column w-100">
            <FormikInput
              name="phoneC1"
              type="number"
              placeholder={t["Phone Number"] + "*"}
              data-tooltip-id="phoneC1Tooltip"
              data-tooltip-content={t["Phone Number"] + "*"}
            />
            <ReactTooltip id="phoneC1Tooltip" type="dark" effect="solid" />
          </div>
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikInput
            name="designation"
            placeholder={t["Designation"] + "*"}
            data-tooltip-id="designationTooltip"
            data-tooltip-content={t["Designation"] + "*"}
          />
          <ReactTooltip id="designationTooltip" type="dark" effect="solid" />
        </div>
      </div>
      <div className="form-check form-switch my-3 w-25">
        <label
          className="form-check-label text-secondary fw-bold"
          htmlFor="isSecondaryContact"
        >
          {t["Add secondary contact?"]}
        </label>
        <input
          className="form-check-input mt-1"
          type="checkbox"
          id="isSecondaryContact"
          data-tooltip-id="isSecondaryTooltip"
          data-tooltip-content="Toggle to add the secondary contact details"
          onChange={toggleSwitch}
        />
        <ReactTooltip id="isSecondaryTooltip" type="dark" effect="solid" />
      </div>
      {isSecondaryContact && (
        <div
          className="col-12 row me-0 pe-0 mb-3"
          style={{
            border: "1px dashed rgb(203, 203, 203)",
            borderRadius: "15px",
          }}
        >
          <div className="col-12 mt-3">
            <h6 className="text-center text-secondary fw-bold">
              {t["Secondary Contact Details"]}
            </h6>
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              name="firstNameC2"
              placeholder={t["First Name"] + "*"}
              data-tooltip-id="fNameC2Tooltip"
              data-tooltip-content={t["First Name"] + "*"}
            />
            <ReactTooltip id="fNameC2Tooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              name="lastNameC2"
              placeholder={t["Last Name"] + "*"}
              data-tooltip-id="lNameC2Tooltip"
              data-tooltip-content={t["Last Name"] + "*"}
            />
            <ReactTooltip id="lNameC2Tooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              onChange={onChange}
              handleOnBlur={async (e) => {
                const { value, name } = e.target;
                setFieldTouched(name, true);
                // console.log("first", value);
                // Call the API to check if the account number exists
                try {
                  const response = await Promise.all([
                    checkApi({
                      params: { user: value },
                      endpoint: "/onboarding/user_check",
                    }),
                  ]);

                  const [userCheckResponse = {}] = response;

                  if (userCheckResponse?.result?.result?.exists === true) {
                    // console.log(
                    //   "check account number response if exists",
                    //   accountCheckResponse?.result?.result?.exists
                    // );

                    setFieldValue("email_C2_exists", true);
                  } else {
                    setFieldValue("email_C2_exists", false);
                  }
                } catch (error) {
                  console.error("Error checking account number:", error);
                } finally {
                  handleCloseLoader();
                }
              }}
              name="emailC2"
              placeholder={t["Email Address"] + "*"}
              data-tooltip-id="emailTooltip"
              data-tooltip-content={t["Email Address"] + "*"}
            />
            <ReactTooltip id="emailTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-6 col-12 d-flex">
            <FormikInput name="phone_prefix" readOnly />
            <div className="d-flex flex-column w-100">
              <FormikInput
                name="phoneC2"
                type="number"
                placeholder={t["Phone Number"] + "*"}
                data-tooltip-id="phoneC2Tooltip"
                data-tooltip-content={t["Phone Number"] + "*"}
              />
              <ReactTooltip id="phoneC2Tooltip" type="dark" effect="solid" />
            </div>
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              name="designationC2"
              placeholder={t["Designation"] + "*"}
              data-tooltip-id="designationC2Tooltip"
              data-tooltip-content={t["Designation"] + "*"}
            />
            <ReactTooltip
              id="designationC2Tooltip"
              type="dark"
              effect="solid"
            />
          </div>
        </div>
      )}
      <div
        className="col-12 row me-0 pe-0 mb-3"
        style={{
          border: "1px dashed rgb(203, 203, 203)",
          borderRadius: "15px",
        }}
      >
        <div className="col-12 mt-3">
          <h6 className="text-center text-secondary fw-bold">
            {t["Business Details"]}
          </h6>
        </div>
        <div className="my-3 col-12">
          <FormikInput
            name="business_name"
            onChange={onChangeBusinessName}
            handleOnBlur={async (e) => {
              const { value, name } = e.target;
              setFieldTouched(name, true);
              // console.log("first", value);
              // Call the API to check if the account number exists
              try {
                const response = await Promise.all([
                  checkApi({
                    params: { company_name: value },
                    endpoint: "/vtex/check_company",
                  }),
                ]);

                const [companyCheckResponse = {}] = response;

                if (companyCheckResponse?.result?.result?.exists === true) {
                  // console.log(
                  //   "check account number response if exists",
                  //   accountCheckResponse?.result?.result?.exists
                  // );

                  setFieldValue("store_name_exist", true);
                } else {
                  setFieldValue("store_name_exist", false);
                }
              } catch (error) {
                console.error("Error checking account number:", error);
              } finally {
                handleCloseLoader();
              }
            }}
            placeholder={t["Store Name"] + "*"}
            data-tooltip-id="displayNameTooltip"
            data-tooltip-content={t["Store Name"] + "*"}
          />
          <ReactTooltip id="displayNameTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-12">
          <FormikInput
            name="vtex_business_name"
            onChange={onChangeBusinessName}
            handleOnBlur={async (e) => {
              const { value, name } = e.target;
              setFieldTouched(name, true);
                  console.log("API Params:", { business_name: value });

              // console.log("first", value);
              // Call the API to check if the account number exists
              try {
                const response = await Promise.all([
                  checkApi({
                    params: { business_name: value },

                    endpoint: "/onboarding/verify/business",
                  }),
                ]);

                const [companyCheckResponse = {}] = response;

                if (companyCheckResponse?.result?.result?.exists === true) {
                  // console.log(
                  //   "check account number response if exists",
                  //   accountCheckResponse?.result?.result?.exists
                  // );

                  setFieldValue("business_name_exist", true);
                } else {
                  setFieldValue("business_name_exist", false);
                }
              } catch (error) {
                console.error("Error checking account number:", error);
              } finally {
                handleCloseLoader();
              }
            }}
            placeholder={t["Legal Business Name (As per CR)"] + "*"}
            data-tooltip-id="businessNameTooltip"
            data-tooltip-content={t["Legal Business Name (As per CR)"] + "*"}
          />
          <ReactTooltip id="businessNameTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-12 d-none domain-input-wrapper ">
          <input
            name="domain_name"
            ref={domainRef}
            maxLength="10"
            onChange={(e) => {
              const { name, value } = e.target;
              setFieldValue(name, value);
              setFieldValue("domain", `${value}.${COMPANY_DOMAIN}`);
            }}
            type="text"
            className="domain-input form-control"
            placeholder={t["Domain Name"]}
            aria-label="Domain"
            aria-describedby="basic-addon2"
          />
          <span
            style={{ height: 56 }}
            className="input-group-text responsive-ellipsis"
            id="basic-addon2"
          >
            .{COMPANY_DOMAIN}
          </span>
        </div>
      </div>
    </>
  );
};

export default VtexVerifyEmailStep;
